import { render, staticRenderFns } from "./UserDetailSelfPage.vue?vue&type=template&id=6203dc54&scoped=true&lang=pug&"
import script from "./UserDetailSelfPage.vue?vue&type=script&lang=js&"
export * from "./UserDetailSelfPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6203dc54",
  null
  
)

export default component.exports